import {
  IonIcon,
  IonTitle,
  IonHeader,
  IonButton,
  IonFooter,
  IonToolbar,
  IonContent,
  IonButtons,
} from '@ionic/angular/standalone';
import { Component, input, OnInit, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular/standalone';
import { close, notificationsCircleOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';

@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
  imports: [IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonButtons, IonFooter, IonIcon],
})
export class NotificationPopupComponent implements OnInit {
  private modalCtrl = inject(ModalController);
  private domSanitizer = inject(DomSanitizer);

  title = input('', { transform: (v) => v || 'Notification' });
  html = input('');

  sanitizedHtml: SafeHtml = '';

  constructor() {
    addIcons({ close, notificationsCircleOutline });
  }

  ngOnInit(): void {
    // DomSanitizer.sanitize strips dangerous tags/attributes but keeps h1, p, b, i, ul, li
    const clean = this.domSanitizer.sanitize(SecurityContext.HTML, this.html()) ?? '';
    this.sanitizedHtml = this.domSanitizer.bypassSecurityTrustHtml(clean);
  }

  dismiss(): Promise<boolean> {
    return this.modalCtrl.dismiss();
  }
}
